import React from 'react'
import { Footer, Header, HeroSection } from '../components'

const CovidTesting = () => {
    return (
        <>
            <Header />
            <HeroSection
                pageName="Covid-19 Testing"
                pageDescription="
                    With our expertise, professionalism, state-of-the-art and
                    highly sterile laboratories for your test needs, highly
                    skilled, trained and experienced staff, we aim to be the
                    leading voice of transformation and improvement of
                    health care in Uganda.
                "
                companyName="SameDay Laboratories"
                showBreadcrumb={true}
            />
            <Footer />
        </>
    )
}

export default CovidTesting